import { createSlice, PayloadAction } from '@reduxjs/toolkit';

const slice = createSlice({
  name: 'disableAllBrandsMenuTab',
  initialState: false,
  reducers: {
    setDisableAllBrandsMenuTab(state, action: PayloadAction<boolean>) {
      return action.payload;
    },
  },
});

export const { setDisableAllBrandsMenuTab } = slice.actions;

export default slice.reducer;
